import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedBudgetsReducer(state = initialState.selectedBudgets, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_BUDGETS_SUCCESS:
      return action.selectedBudgets;
    default:
      return state;
  }
}
